export const ru = {
    'all-audience': 'Вся аудитория',
    'by-selected-region': 'В выбранном регионе',
    metrikaAudience: 'Яндекс.Аудитории и Яндекс.Метрика',
    'users-profiles': 'Профиль пользователя'
};
